'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageMovieCreation = function ImageMovieCreation(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z' })
  );
};
ImageMovieCreation = (0, _pure2.default)(ImageMovieCreation);
ImageMovieCreation.displayName = 'ImageMovieCreation';
ImageMovieCreation.muiName = 'SvgIcon';

exports.default = ImageMovieCreation;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/image/movie-creation.js
 ** module id = 2123
 ** module chunks = 0
 **/